import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import {
  ADDRESS_BY_CHAIN_CRONOS_EVM,
  ADDRESS_BY_CHAIN_L1,
  ADDRESS_BY_CHAIN_L2,
  getRelatedCronosEvmChain,
  getRelatedL2Chain,
} from '@cronos-app/sdk';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getEthToken: TokenRegister = (desiredNetwork) => {
  return {
    type: Token.ETH,
    symbol: 'ETH',
    addressL1: ADDRESS_BY_CHAIN_L1[desiredNetwork].ETH,
    addressL2: ADDRESS_BY_CHAIN_L2[getRelatedL2Chain(desiredNetwork)].ETH,
    addressCronosEvm:
      ADDRESS_BY_CHAIN_CRONOS_EVM[getRelatedCronosEvmChain(desiredNetwork)].ETH,
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/eth.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="eth"
        {...props}
      />
    ),
  };
};
